// extracted by mini-css-extract-plugin
export default {"container":"Login_container__+Ihqx","form":"Login_form__HoQ6M"};